import React from 'react';
import { ContainerStyled } from './styles';
var DefaultLayout = function (_a) {
    var children = _a.children;
    return (React.createElement(ContainerStyled, null, children));
};
export default DefaultLayout;
